var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.title ? _c("span", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
      _c("v-autocomplete", {
        attrs: {
          label: _vm.label,
          "item-text": "title",
          "item-value": "id",
          outlined: "",
          clearable: "",
          autofocusx: "",
          "hide-no-data": "",
          "auto-select-first": "",
          "hide-selected": false,
          items: _vm.citiesFiltered,
          "search-input": _vm.searchCity,
          "error-messages": _vm.errors,
          loading: _vm.$apollo.queries.cities.loading || _vm.loading,
          disabled: _vm.loading,
        },
        on: {
          "update:searchInput": function ($event) {
            _vm.searchCity = $event
          },
          "update:search-input": function ($event) {
            _vm.searchCity = $event
          },
          "input:append": function ($event) {
            return _vm.$emit("change", $event)
          },
        },
        model: {
          value: _vm.cityId,
          callback: function ($$v) {
            _vm.cityId = $$v
          },
          expression: "cityId",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }